/**
 * <TutorLiveAlertList> — ce qui alerte le masteur, au-dessus du centre du live (molecule).
 *
 * L'ancienne `ConnectionQualityAlert` (« Connexion faible. Déplace-toi. », « La connexion de {nom} est
 * faible ») et la bulle de la barre (« Ta caméra est peut-être masquée » / « Vérifie qu'aucun cache ne
 * recouvre l'objectif. », et sa croix) : un bandeau teinté par alerte (`<Banner>`), sa phrase et son
 * détail, et la croix quand l'alerte se ferme. Une alerte qui dit un état (une connexion) part seule
 * quand l'état part : elle n'a pas de croix.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { type UITutorLiveAlert } from "../../../ports/primary/ui/types/tutorLive"
import { Banner } from "../../atoms/Banner"
import { IconButton } from "../../atoms/Buttons/IconButton"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"

export type TutorLiveAlertListProps = {
    alerts: UITutorLiveAlert[]
    onDismiss?: (alertId: string) => void
    testID?: string
}

export function TutorLiveAlertList(props: TutorLiveAlertListProps) {
    const { alerts, onDismiss, testID } = props
    if (alerts.length === 0) return null
    return (
        <Stack gap="2" testID={testID}>
            {alerts.map((alert) => (
                <View key={alert.id} style={styles.row}>
                    <Banner
                        style={styles.banner}
                        color={alert.tone}
                        icon={alert.tone === "danger" ? "exclamation-circle" : "exclamation-triangle"}
                        align="start"
                        tinted
                        message={
                            <Stack gap="0">
                                <Text size="text-sm" weight="bold" color="text-strong">
                                    {alert.text}
                                </Text>
                                {alert.detail != null && (
                                    <Text size="text-sm" color="text-muted">
                                        {alert.detail}
                                    </Text>
                                )}
                            </Stack>
                        }
                    />
                    {alert.dismissible === true && onDismiss != null && (
                        <IconButton
                            iconName="times"
                            appearance="transparent"
                            iconColor="text-muted"
                            size={32}
                            iconSize={16}
                            onPress={() => onDismiss(alert.id)}
                            accessibilityLabel={`Fermer : ${alert.text}`}
                        />
                    )}
                </View>
            ))}
        </Stack>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: { flexDirection: "row", alignItems: "center", gap: theme.spacing["1"] },
    banner: { flex: 1 },
}))
